import React from "react";
const IR330CPageTitle = () => {
  return (
    <div className="row " style={{ marginTop: "50px", marginBottom: "10px", clear: "both" }}>
      <div className="col-md-12">
        <div className="row">
          <span className="page-title pb-0">Use this form if you’re an employee receiving salary or wages, or you receive a main benefit or NZ superannuation.</span> <br />
          <span className="page-title pb-3">If you’re a contractor using <strong>WT</strong> tax code, use the <strong>Tax rate notification for contractors - IR330C</strong> form.</span>
        </div>
      </div>
    </div>
  )
}

export default IR330CPageTitle;